export default __webpack_public_path__ + "static/media/04.7aa43621.jpg";